const SectionSignIn = Class(
	/**
	 * @lends {SectionSignIn#}
	 */
	{
		bodyClass: 'small-nav',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'sign-up',
				className: 'container'
			});
		},

		route() {
			if (D.ID && this.url.get.is('validate')) {
				return;
			}
			if (D.ID) {
				Section.navigate(D.url('profile'), {
					popState: true
				});
				return false;
			}
		},

		draw() {
			this.node.append(this.layout.ct());
			this._left = mkE({
				tag: 'div',
				className: 'left center'
			}).append(this.node);
			this._form = new SectionSignIn.Form(this.url).append(this._left);
			this.ready();
		},

		onShow() {
			//this._form._fields['email'].focus();
		}
	},
	Section
);

SectionSignIn.Form = Class(
	/**
	 * @lends {SectionSignIn.Form#}
	 */
	{
		_fields: {},

		__construct(url) {
			this.url = url;
			let signUpUrl = D.url('sign-up');
			if (this.url.get.v('redirect')) {
				let g = new Get(signUpUrl);
				g.add('redirect', this.url.get.v('redirect'));
				signUpUrl = g.toUrl();
			}

			this.node = mkE({
				tag: 'div',
				className: 'sign-up-form',
				els: [
					{
						tag: 'div',
						className: 'top',
						els: [
							{
								tag: 'h1',
								className: 'h2',
								text: D.Lang.get('sign-in.title')
							},
							{
								tag: 'div',
								className: 'caption',
								els: [
									D.Lang.get('sign-in.caption') + ' ',
									{
										tag: 'a',
										href: signUpUrl,
										text: D.Lang.get('sign-in.register')
									}
								]
							}
						]
					}
				]
			});

			mkE({
				tag: 'div',
				className: 'auth',
				els: [
					{
						tag: 'div',
						className: 'social-auth',
						els: [
							{
								tag: 'a',
								className: 'facebook',
								onclick: D.Social.facebook,
								els: [
									{
										tag: 'span'
									},
									D.Lang.get('sign-up.social.facebook')
								]
							},
							{
								tag: 'a',
								className: 'google',
								onclick: D.Social.google,
								els: [
									{
										tag: 'span'
									},
									D.Lang.get('sign-up.social.google')
								]
							},
							D.LANG === 'lv' ? {
								tag: 'a',
								className: 'draugiem',
								onclick: D.Social.draugiem,
								els: [
									{
										tag: 'span'
									},
									D.Lang.get('sign-up.social.draugiem')
								]
							} : ''
						]
					},
					{
						tag: 'div',
						className: 'or',
						els: [
							{
								tag: 'div',
								className: 'line line-1'
							},
							{
								tag: 'div',
								className: 'text',
								text: D.Lang.get('sign-up.or')
							},
							{
								tag: 'div',
								className: 'line line-1'
							}
						]
					},
					this._authForm = mkE({
						tag: 'div',
						className: 'auth-form'
					})
				]
			}).append(this.node);

			this._drawForm();
		},

		_drawForm() {
			this._form = mkE({
				tag: 'form',
				className: 'form',
				prop: {
					onsubmit: this._submit
				}
			}).append(this._authForm);

			mkE({
				tag: 'div',
				className: 'row',
				els: [
					this._fields['email'] = new T.Form.Input({
						caption: D.Lang.get('sign-up.form.email'),
						type: 'email',
						attr: {
							autofocus: true
						}
					})
				]
			}).append(this._form);

			mkE({
				tag: 'div',
				className: 'row',
				els: [
					this._fields['password'] = new T.Form.Input({
						caption: D.Lang.get('sign-up.form.password'),
						type: 'password'
					})
				]
			}).append(this._form);

			mkE({
				tag: 'div',
				className: 'row bottom',
				els: [
					{
						tag: 'div',
						className: 'left',
						els: [
							{
								tag: 'button',
								className: 'button button-pink button-block',
								text: D.Lang.get('sign-in.submit'),
								onclick: this._submit
							}
						]
					},
					{
						tag: 'div',
						className: 'right forgot',
						els: [
							{
								tag: 'a',
								href: D.url('/forgot-password'),
								text: D.Lang.get('sign-in.forgot')
							}
						]
					}
				]
			}).append(this._form);

			if (this.url.get.is('pwd-reset')) {
				this._successNode = T.success(D.Lang.get('forgot-password.reset.complete'), true).prepend(this._form);
			}
		},

		_submit() {
			if (this._isSubmitting) {
				return false;
			}
			if (this._errorNode) {
				this._errorNode.remove();
			}
			if (this._successNode) {
				this._successNode.remove();
			}
			let data = {};
			let hasError = false;
			for (let field in this._fields) {
				if (!this._fields.hasOwnProperty(field)) {
					continue;
				}
				this._fields[field].error(null);
				if (!this._fields[field].value()) {
					hasError = true;
					this._fields[field].error(D.Lang.get('sign-up.errors.empty'))
				} else if (field === 'email' && !T.Form.isValidEmail(this._fields[field].value())) {
					hasError = true;
					this._fields[field].error(D.Lang.get('sign-up.errors.' + field + '.format'))
				}
				data[field] = this._fields[field].value();
			}
			if (hasError) {
				return false;
			}
			if (this.url.get.is('redirect')) {
				data['redirect'] = this.url.get.v('redirect');
			}
			this._isSubmitting = true;
			new RPC('/api/web_rpc.php').send('login', data, this._onSubmit);
			return false;
		},

		_onSubmit(re) {
			if (empty(re)) {
				this._errorNode = T.error(D.Lang.get('sign-in.errors.general'), true).prepend(this._form);
				return;
			}
			if (re.ok) {
				D.Analytics.branch('LOGIN', {
					"description": "Login",
					"user_id": re.userId
				});
				window.location.href = re.url;
				return;
			}
			this._isSubmitting = false;
			if (!empty(re.error)) {
				if (typeof re.error === 'object') {
					for (let field in re.error) {
						if (!re.error.hasOwnProperty(field)) {
							continue;
						}
						this._fields[field].error(D.Lang.get('sign-in.errors.' + field + '.' + re.error[field]));
					}
				} else {
					this._errorNode = T.error(D.Lang.get('sign-in.errors.general'), true).prepend(this._form);
				}
			} else {
				D.Analytics.branch('COMPLETE_REGISTRATION', {
					"description": "Registration completed",
					"user_id": re.userId
				});
			}
		}
	},
	mkE.Base
);
